<dialog-header [label]="'MENUBAR.HEADER_CONNECT_SERVER' | translate" [dialogRef]='dialogRef' [object]='this'></dialog-header>
<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onConnect()">
    <mat-form-field><input matInput placeholder="Server" formControlName="serverField"></mat-form-field>
    <mat-form-field><input matInput placeholder="SoundAddress" formControlName="soundAddress"></mat-form-field>
    <mat-form-field><input matInput placeholder="SoundToken" formControlName="soundToken"></mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="true" (click)="onConnect()" cdkFocusInitial>{{'ACTIONS.CONNECT' | translate}}</button>
  <button mat-stroked-button [mat-dialog-close]="true" (click)="onConnectSound()" cdkFocusInitial>Connect sound</button>
  <button mat-stroked-button [mat-dialog-close]="false">{{'ACTIONS.CLOSE' | translate}}</button>
</mat-dialog-actions>
